<div
  class="lease px-1 app-text-bold app-text-white my-1 py-1 d-flex justify-content-between mb-1 primary-section-header-block align-items-center">
  <app-deal-type-selector (submitDealType)="submitDealType.emit($event)"></app-deal-type-selector>
</div>

<div class="px-1 my-1 pb-1 pt-2 d-flex justify-content-between">
  <span style="font-weight:bold;cursor: default">Monthly Payment</span>
  <div style="display: flex;flex-grow: 0;align-items: center;gap: 2px;justify-content: flex-end"
       (click)="updateMonthlyPriceOverride()" matTooltipPosition="above"
       matTooltip="Click to Override Lease Monthly Payment">
    <div *ngIf="deal.financeOptionsEdits.monthlyPayment !== null" style="cursor: pointer;position: relative">
      <mat-icon [style.color]="'#007bff'" style="position: absolute;top:-10px;left:-20px;">bolt</mat-icon>
    </div>
    <ng-container>
        <span class="app-text-blue hover-link-dotted">
        {{
            deal.financeOptionsEdits.monthlyPayment !== null ?
              (deal.financeOptionsEdits.monthlyPayment | currency) :
              (totalLeaseMonthlyPayment$({
                useCustomLease: !!(customLeaseEnabled && customLeaseMpy && customLeaseResidual)
              }) | async | currency)
          }}
        </span>
    </ng-container>
  </div>
</div>

<app-lender-select
  [readOnly]="true"
  [lender]="lender"
  [lenderName]="lender?.name"
  [flagChange]="flagChange">
</app-lender-select>

<div class="section-header mt-4" style="margin-bottom:0!important;margin-top:16px!important;">Lease Term</div>

<div class="select-field-container">
  <select
    (change)="selectLeaseTerm($event.target)"
    class="form-control border border-primary color my-1">
    <option disabled>Select Term</option>
    <ng-container *ngFor="let term of defaultTerms; let i = index">
      <option [value]="term" [selected]="this.activeLeaseTerm(term)">{{ term }} Months</option>
    </ng-container>
    <option disabled>---------------------</option>
    <ng-container *ngFor="let term of allAvailableTerms; let i = index">
      <ng-container *ngIf="!defaultTerms.includes(term) && leaseForm.value['moneyFactor' + term]>0">
        <option [value]="term" [selected]="this.activeLeaseTerm(term)">{{ term }} Months</option>
      </ng-container>
    </ng-container>
  </select>
</div>

<div>

  <div class="section-header mt-4" style="margin-bottom:0!important;margin-top:16px!important;">Custom Lease Rates</div>
  <div style="padding:0 2px!important;box-sizing: border-box" [style.display]="customLeaseEnabled ? 'block':'none'">
    <div class="app-inline-form-layout form-header-row cursor-default">
      <span></span>
      <span class="app-text-small app-text-bold">MPY</span>
      <span class="app-text-small app-text-bold">Residual</span>
      <span class="app-text-small app-text-bold">Payment</span>
    </div>

    <form class="custom-rate-row">

      <div
        *ngIf="!customLeaseMpyEditing"
        (click)="startEditingMpy()"
        class="app-text-blue editable">
        {{ customLeaseMpy | number }}
      </div>

      <input
        *ngIf="customLeaseMpyEditing"
        (focusin)="customLeaseMpyEditingStarted($event)"
        (blur)="customLeaseMpyEditingComplete($event.target.value)"
        (keydown)="customLeaseMpyKeyDown($event)"
        class="input-underline restrict-width"
        type="number"
        min="0"
        #inputFieldMpy/>

      <div
        *ngIf="!customLeaseResidualEditing"
        (click)="startEditingResidual()"
        class="app-text-blue editable">
        {{ customLeaseResidual | currency }}
      </div>

      <input
        *ngIf="customLeaseResidualEditing"
        (focusin)="customLeaseResidualEditingStarted($event)"
        (blur)="customLeaseResidualEditingComplete($event.target.value)"
        (keydown)="customLeaseResidualKeyDown($event)"
        class="input-underline restrict-width"
        type="number"
        #inputFieldResidual
        min="0"/>

      <ng-template #customPriceNotAvailable>
        <div [ngClass]="'app-bg-gray app-text-black'">---</div>
      </ng-template>

      <ng-container *ngIf="customLeaseEnabled && customLeaseResidual && customLeaseMpy; else customPriceNotAvailable">
        <div
          [ngClass]="'app-bg-success app-text-white'">{{
            totalLeaseMonthlyPayment$({
              useCustomLease: !!(customLeaseEnabled && customLeaseMpy && customLeaseResidual)
            }) | async | currency
          }}
        </div>
      </ng-container>

    </form>
  </div>
</div>

<div style="margin-top:10px;">
  <button
    *ngIf="!customLeaseEnabled"
    class="btn app-btn-success rounded-pill px-2 py-0 small-green-button"
    style="font-size: 0.8rem;margin-left:5px;margin-bottom:5px;margin-top:2px;"
    (click)="enableCustomLease()">Enter Custom Lease
  </button>
  <button
    *ngIf="customLeaseEnabled"
    class="btn app-btn-success rounded-pill px-2 py-0 small-green-button"
    style="font-size: 0.8rem;margin-left:5px;margin-bottom:5px;margin-top:4px;"
    (click)="disableCustomLease()">Remove Custom Lease
  </button>
</div>

<div class="section-header" style="margin-top:14px!important;">Standard Lease Rates</div>

<article *ngFor="let option of leaseTerms; let i = index">
  <ng-container *ngIf="this.activeLeaseTerm(option.term)">

    <!--<div class="w-100">
      <div class="d-flex align-items-center mb-2 mt-2 ml-1">
        <input
          [ngClass]="checkBoxColor"
          (click)="onSelectLeaseTerm(option.term)"
          [checked]="this.activeLeaseTerm(option.term)"
          [disabled]="!leaseSelected"
          type="checkbox"
          class="check-box-btn mr-2"/>
        <span class="cursor-default color-grey-4">{{option.term}} Months</span>
      </div>
    </div>-->

    <div class="app-inline-form-layout form-header-row cursor-default">
      <span></span>
      <span class="app-text-small app-text-bold">MPY</span>
      <span class="app-text-small app-text-bold">Residual</span>
      <span class="app-text-small app-text-bold">Payment</span>
    </div>

    <ng-container *ngIf="option.term!==24">

      <div
        (click)="updateEstMPY(option.term, 10000)"
        class="app-inline-form-layout {{isCurrentlySelectedResidual(option.term, 10000,customLeaseEnabled,customLeaseMpy,customLeaseResidual) ? (leaseSelected ? 'row-selected-blue' : 'row-selected-grey') : 'lease-rate-row'}}">
        <span></span>
        <span>10,000</span>
        <span>{{ option.lowest | currency }}</span>
        <span>{{
            totalLeaseMonthlyPayment$({
              term: option.term,
              residualValue: option.lowest,
              useCustomLease: false
            })| async | currency
          }}</span>
      </div>

    </ng-container>

    <div
      (click)="updateEstMPY(option.term, 12000)"
      class="app-inline-form-layout {{isCurrentlySelectedResidual(option.term, 12000,customLeaseEnabled,customLeaseMpy,customLeaseResidual) ? (leaseSelected ? 'row-selected-blue' : 'row-selected-grey') : 'lease-rate-row'}}">
      <span></span>
      <span>12,000</span>
      <span>{{ option.low | currency }}</span>
      <span>{{
          totalLeaseMonthlyPayment$({
            term: option.term,
            residualValue: option.low,
            useCustomLease: false
          }) | async | currency
        }}</span>
    </div>

    <div
      (click)="updateEstMPY(option.term, 15000)"
      class="app-inline-form-layout {{isCurrentlySelectedResidual(option.term, 15000,customLeaseEnabled,customLeaseMpy,customLeaseResidual) ? (leaseSelected ? 'row-selected-blue' : 'row-selected-grey') : 'lease-rate-row'}}">
      <span></span>
      <span>15,000</span>
      <span>{{ option.standard | currency }}</span>
      <span>{{
          totalLeaseMonthlyPayment$({
            term: option.term,
            residualValue: option.standard,
            useCustomLease: false
          })| async | currency
        }}</span>
    </div>

    <hr class="standard-section-breaker">

    <app-simple-input
      [parentForm]="leaseForm"
      [formCtrlName]="'moneyFactor' + option.term"
      [fieldValue]="leaseForm.value['moneyFactor' + option.term]"
      [name]="'Money Factor'"
      [type]="'number'"
      [blur]="submitLeaseForm"
      [keydown]="flagChange"
      [disabled]="uiState.selectedLeaseTerm !== option.term">
    </app-simple-input>

  </ng-container>

</article>

<div style="display:flex;gap:2px;align-items: center">
  <input
    type="checkbox"
    class="form-check"
    [checked]="!leaseForm?.get('subventionCashDisabled').value"
    (click)="toggleSubventionCashDisabled()"/>
  <app-simple-input
    formCtrlName="subventionCash"
    name="Lease Subvention"
    type="number"
    pipe="currency"
    [parentForm]="leaseForm"
    [fieldValue]="uiState.subventionCash"
    [blur]="submitLeaseForm"
    [keydown]="flagChange">
  </app-simple-input>
</div>

<app-simple-input
  [parentForm]="leaseForm"
  [formCtrlName]="'acquisitionFee'"
  [fieldValue]="leaseOptions?.acquisitionFee"
  [name]="'Acquisition Fee'"
  [type]="'number'"
  [blur]="submitLeaseForm"
  [keydown]="flagChange"
  [pipe]="'currency'">
</app-simple-input>

<app-simple-input
  *ngIf="uiState.rateMarkup"
  [parentForm]="leaseForm"
  [formCtrlName]="'rateMarkup'"
  [fieldValue]="uiState.rateMarkup"
  [name]="'Rate Markup'"
  [type]="'number'"
  [blur]="submitLeaseForm"
  [keydown]="flagChange"
  [pipe]="'currency'">
</app-simple-input>

<app-simple-input
  [parentForm]="excessMilesForm"
  [formCtrlName]="'prepaidMilesTotal'"
  [fieldValue]="uiState.prepaidMilesTotal"
  [name]="'Prepaid Miles Total'"
  [type]="'number'"
  [blur]="submitExcessMilesForm"
  [keydown]="flagChange"
  [additionalFieldValue]="excessMilesPerYear$ | async">
</app-simple-input>

<!--<app-smw-rebates-form
  dealType="lease"
  [dealIncentives]="dealIncentives"
  [vehicleIncentives]="vehicleIncentives"
  (updateIncentives)="onUpdateIncentives($event)">
</app-smw-rebates-form>-->

<div class="section-header">Products</div>

<app-smw-insurance-products-form
  [dealDefaults]="dealDefaults"
  [selectedDealTerm]="uiState.selectedLeaseTerm"
  (flagUnsavedChanges)="flagChange()"
  [type]="'lease'">
</app-smw-insurance-products-form>

<!-- <app-simple-input
  [fieldValue]="totalInsuranceProductsPrice$ | async | currency"
  [name]="'Total Protection Adds'"
  [type]="'number'">
</app-simple-input> -->

<!--<app-simple-input
  [fieldValue]="tradeInNetValue$ | async"
  name="Trade Net"
  type="number"
  pipe="currency">
</app-simple-input>-->

<!--<app-simple-input
  [fieldValue]="adjustedCapCost$ | async"
  name="Adjusted Cap Cost"
  type="number"
  pipe="currency">
</app-simple-input>-->
